import { faLanguage } from '@fortawesome/free-solid-svg-icons/faLanguage';
import React from 'react';
import styled from 'styled-components';

import { Images } from '../assets';
import { generalTestIDs } from '../constants/test/general.testIds';
import i18n, { AppLangs, replaceLangPathInUrl } from '../i18n';
import { useAppSelector } from '../redux/store';
import { userSliceSelectors } from '../redux/user/user.selector';
import { Spacing } from '../theme/Spacing';
import { ThemeType } from '../theme/Theme';
import { MenuProps } from '../utils/local-antd';
import { AtiraDropdown } from './AtiraDropdown';
import { AtiraIcon } from './AtiraIcon';
import { Button } from './Button';
import { Flex } from './Flex';
import { AtiraImage } from './Image';

const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: ${Spacing.s};
  padding: 0;
  margin: 0;
  background-color: ${({ theme }) => theme.transparent};
`;

const LanguageWrapper = styled(Flex)`
  justify-content: space-between;
  align-items: center;
  padding: 0;
  margin: 0;
`;

type LanguageSwitcherProps = {
  color?: keyof ThemeType;
  popupPlacement?: 'bottom' | 'topRight';
};

export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
  color = 'iconSecondary',
  popupPlacement = 'bottom',
}) => {
  const isLoggedIn = Boolean(
    useAppSelector(userSliceSelectors.selectLoggedInUserId),
  );

  const changeLanguage = (lang: AppLangs) => {
    if (lang === window.localStorage.getItem('atiralink_lang')) {
      return;
    }

    if (!isLoggedIn) {
      replaceLangPathInUrl(lang);
    }

    i18n.changeLanguage(lang);
  };

  const items: MenuProps['items'] = [
    {
      key: 'g1',
      type: 'group',
      children: [
        {
          key: 'en',
          title: '',
          label: (
            <LanguageWrapper>
              <AtiraImage
                className={generalTestIDs.lang.lang(AppLangs.EN)}
                src={Images.USAFlag}
                width={30}
              />
            </LanguageWrapper>
          ),
          onClick: () => changeLanguage(AppLangs.EN),
        },
        {
          key: 'tr',
          title: '',
          label: (
            <LanguageWrapper>
              <AtiraImage
                className={generalTestIDs.lang.lang(AppLangs.TR)}
                src={Images.TurkishFlag}
                width={30}
              />
            </LanguageWrapper>
          ),
          onClick: () => changeLanguage(AppLangs.TR),
        },
        {
          key: 'ar',
          title: '',
          label: (
            <LanguageWrapper>
              <AtiraImage
                className={generalTestIDs.lang.lang(AppLangs.AR)}
                src={Images.SaudiFlag}
                width={30}
              />
            </LanguageWrapper>
          ),
          onClick: () => changeLanguage(AppLangs.AR),
        },
      ],
    },
  ];

  return (
    <AtiraDropdown
      items={items}
      trigger={['click']}
      arrow={{ pointAtCenter: true }}
      placement={popupPlacement}
      className={generalTestIDs.lang.dropdownContainer}
    >
      <StyledButton>
        <AtiraIcon icon={faLanguage} size="2x" color={color} />
      </StyledButton>
    </AtiraDropdown>
  );
};
